<template>
  <div class="server-product">
    <div class="banner">
      <img src="./images/tutu.png" style="width: 100%" alt="" />
    </div>
    <div class="server-product-main">
      <div class="tabs-container">
        <div class="server-message">
          <template>
            <div class="server-message-title" ref="carTransportation">
              <img src="./images/jiaka_.png" alt="">
            </div>
            <div class="server-message-main">
              <div class="jika">
                <p>
                  运价公开透明，方便客户企业管控物流成本。<br />
                  车队规模大，服务大工厂批量用车可一揽子包干，客户省心省力。<br />
                  小客户能得到公正对待，基于平时下单数据，旺季有保障。<br />
                  拖车运价覆盖全，方便货代客户的销售人员对外报价。<br />
                  提供从船公司放单到目的港卸货的全程货物跟踪信息，直观便捷。<br />
                </p>
                <img src="./images/tu.png" alt="">
              </div>
            </div>
          </template>
          <template>
            <div class="server-message-title" ref="declaration">
              <img src="./images/baoguan.png" alt="">
            </div>
            <div class="server-message-main">
              <p>
                鸭嘴兽与头部报关行合作，为货代企业提供代发舱单、拖车报关一站式服务，合作报关行经验丰富，服务有保障，目前已覆盖上海港、宁波港、深圳港、青岛港及太仓港等多个口岸。客户只需上传报关单据至官网，可随时跟踪报关进度，自主打印报关单放行单。
              </p>
              <div class="advantage">特色优势</div>
              <p>
                鸭嘴兽将拖车与报关紧密协同，报关与进港无缝衔接，确保时效，全链条跟踪数据，最大化避免由于未完成报关而产生的额外费用，真正让客户省心省力。
              </p>
            </div>
          </template>
          <template>
            <div class="server-message-title" ref="supervision">
              <img src="./images/jianyan.png" alt="">
            </div>
            <div class="server-message-main">
              <p>
                鸭嘴兽专业检验团队成员主要来自检测行业国际知名企业，具有多年丰富从业经验，拥有专业证书。在出口货物出运前/进口货物卸货时，按客户具体要求，对数量、包装、唛头、标识、产品描述及其它特别要求内容进行核查检验，并出具专业报告。
              </p>
              <div class="advantage">特色优势</div>
              <p>
                <span style="font-weight: 600;">价格优势</span>
                结合拖车的一体式服务：低协调成本、低路费成本、可微利甚至无利。<br>
                
                <span style="font-weight: 600;">直观、可控、低风险性</span>
                客户可以免费通过鸭嘴兽定制摄像头，远程实时查看集装箱装箱现场，随时可暂停、回看、追查等，监装过程直观透明。
              </p>
            </div>
          </template>
          <template>
            <div class="server-message-title" ref="shuzi">
              <img src="./images/shuzi.png" alt="">
            </div>
            <div class="server-message-main">
              <p>
                鸭嘴兽基于自身经验积累，围绕集装箱公路运输的相关场景打造数字化协同解决方案，研发了一系列软件产品。
              </p>
              <div class="product">E装卸</div>
              <p>
                E装卸车辆预约管理系统是鸭嘴兽为仓库、工厂提供的一整套从车辆装卸预约到运输作业完成整个作业生命周期全流程可视化管理的SaaS平台。提供车辆到场预约、到场排队叫号，库内作业节点反馈，离场送达等全链路可视化管理功能。<br>
                <span style="font-weight: 600;">优势</span>：SaaS化部署，实施周期短，用户投入成本低，有网就能用，上手使用快。
              </p>
              <div class="product">跨境物流助手</div>
              <p>
                跨境物流助手是鸭嘴兽基于腾讯企业QQ打造的一款通过提单号，船名、航次一键查询港口数据，船舶计划、箱动态、海放、码放等关键节点信息的数据协同工具，让用户在企业QQ沟通的场景下直接获取相关节点数据，提高沟通效率。
              </p>
              <p>
                <span style="font-weight: 600;">优势</span>：基于QQ聊天场景直接提供数据服务，用户无需切换其他网站查询，提高工作效率。节点订阅推送，避免重要节点遗漏，异常节点第一时间提醒。
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerAndFooter from "../../components/header-and-footer";
export default {
  name: "server-product",
  data() {
    return {};
  },
  components: {
    "header-and-footer": headerAndFooter,
  },
  computed: {
    tabsParams() {
      // return this.$route.query.tabsName;
    },
  },
  watch: {
    // '$route' (to, from) {
    //     console.log(from);
    //     this.chooseTabs(from.tabsName)
    // }
    // $route: {
    //   handler: function(route) {
    //     console.log('comin channel-edit', route)
    //     this.chooseTabs(route.query.tabsName)
    //   },
    //   immediate: true
    // }
    
    '$route.query.tabsName': {
      handler: function(val, oldVal){
        this.chooseTabs(val)
      },
      deep: true,
    }
  },
  mounted() {
    console.log(this.$route.query);
    this.chooseTabs(this.$route.query.tabsName)
  },
  methods: {
    chooseTabs(params) {
      switch (params) {
        case "0":
          this.$refs['carTransportation'].scrollIntoView({ block: 'center', behavior: 'smooth' });
          console.log(this.$refs['carTransportation']);
          break;
        case "1":
          this.$refs['declaration'].scrollIntoView({ block: 'center', behavior: 'smooth' });
          break;
        case "2":
          this.$refs['supervision'].scrollIntoView({ block: 'center', behavior: 'smooth' });
          break;
        case "3":
          this.$refs['shuzi'].scrollIntoView({ block: 'center', behavior: 'smooth' });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less">
.server-product {
  .ivu-tabs-nav .ivu-tabs-tab-active {
    width: 111px;
    color: #02cad6;
  }
  .ivu-tabs-ink-bar {
    background-color: #02cad6;
  }
  .ivu-tabs-tab {
    font-size: 20px;
  }
  .ivu-tabs-tab:hover {
    color: #02cad6 !important;
  }
  .ivu-tabs-tab-active {
    color: #02cad6;
  }
}
</style>

<style scoped lang="less">
.server-product {
  padding-top: 5rem;
  .server-product-main {
    padding: 1.5rem 0;
    .tabs-container {
      width: 1200px;
      margin: 0 auto;
      .server-tabs {
        font-size: 20px;
      }
      .tabs-title {
        display: flex;
        position: relative;
        .tabs-bar {
          position: absolute;
          height: 2px;
          box-sizing: border-box;
          background-color: #02cad6;
          position: absolute;
          left: 0;
          bottom: 1px;
          z-index: 1;
          visibility: visible;
          width: 111px;
          transition: transform 0.3s ease-in-out;
          transform-origin: 0 0;
          // transform: translate3d(0px, 0px, 0px);
        }
        .tabs-title-item {
          display: inline-block;
          height: 100%;
          padding: 8px 16px;
          margin-right: 16px;
          font-size: 20px;
          box-sizing: border-box;
          // transition: color .3s ease-in-out;
          cursor: pointer;
        }
      }
      .server-message {
        .server-message-title {
          img {
            display: block;
            width: 238px;
            margin: 30px auto;
          }
        }
        .server-message-main {
          padding: 30px;
          margin-bottom: 60px;
          background-color: rgb(242, 249, 249);
          .jika {
            display: flex;
            justify-content: space-between;
          }
          .advantage {
            color:#02cad6;
            font-weight: 600;
            text-align: center;
            line-height: 68px;
            font-size: 24px;
          }
          .product {
            color:#02cad6;
            font-weight: 600;
            line-height: 68px;
            font-size: 24px;
          }
          p {
            font-size: 16px;
            line-height: 30px;
          }
          img {
            display: block;
            width: 300px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// server-product.vue?b37d8b9c